import type { IUnauthorizedErrorResources } from "./Unauthorized.Resources";

export const UnauthorizedErrorResourcesEn: IUnauthorizedErrorResources = {
    login: "Sign in",
    needLogin: "Only available for logged user.",
    register: "Sign up",
    needAccount: "You do not have an account?",
};
